// extracted by mini-css-extract-plugin
export default {"sectionSoft":"HomePage_sectionSoft__Rq8Ob","sectionNone":"HomePage_sectionNone__KeDUH"};